import { Flex, Heading, Image, Paragraph } from '@customerio/pluma-components/react';
import { sanitizeHtml } from '@/utils/sanitize';
import { integrationImageSrc } from '@/features/integrations';
import type { Integration } from '@/services/db/integration/entity';
import * as styles from './data-out-connector-header.css';

type DataOutConnectorHeaderProps = {
  integration: Integration;
};

/**
 * The connector's logo, name, and catalog blurb.
 *
 * `details_page_description` is server-authored catalog copy carrying links and light emphasis, so
 * it is rendered as HTML through the shared sanitizer. Note the sanitizer drops `rel`, which the
 * catalog pairs with `target="_blank"`; browsers imply `noopener` for `target="_blank"` anyway.
 */
export function DataOutConnectorHeader({ integration }: DataOutConnectorHeaderProps) {
  const imageSrc = integrationImageSrc(integration);

  return (
    <>
      <Flex alignItems="center" gap="100" mb="150">
        {imageSrc === '' ? null : <Image className={styles.logo} src={imageSrc} alt={integration.name} />}
        <Heading level="1">{integration.name}</Heading>
      </Flex>

      <Paragraph
        className={styles.description}
        // nosemgrep: react-dangerouslysetinnerhtml — Customer.io's own catalog copy, sanitized via DOMPurify in sanitizeHtml()
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(integration.details_page_description) }}
      />
    </>
  );
}
